/**
 * 路由常量定义
 * 统一管理路由名称和路径
 */

/**
 * 路由名称常量
 */
export const ROUTE_NAMES = {
  // 根路由
  ROOT: 'root',

  // 认证相关
  LOGIN: 'login',
  LOGOUT: 'logout',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',

  // 主要页面
  DASHBOARD: 'dashboard',
  HOME: 'home',

  // 系统管理
  SYSTEM: 'system',
  SYSTEM_USER: 'system-user',
  SYSTEM_USER_LIST: 'system-user-list',
  SYSTEM_USER_ADD: 'system-user-add',
  SYSTEM_USER_EDIT: 'system-user-edit',
  SYSTEM_USER_DETAIL: 'system-user-detail',

  SYSTEM_ROLE: 'system-role',
  SYSTEM_ROLE_LIST: 'system-role-list',
  SYSTEM_ROLE_ADD: 'system-role-add',
  SYSTEM_ROLE_EDIT: 'system-role-edit',
  SYSTEM_ROLE_DETAIL: 'system-role-detail',

  SYSTEM_PERMISSION: 'system-permission',
  SYSTEM_PERMISSION_LIST: 'system-permission-list',
  SYSTEM_PERMISSION_ADD: 'system-permission-add',
  SYSTEM_PERMISSION_EDIT: 'system-permission-edit',
  SYSTEM_PERMISSION_DETAIL: 'system-permission-detail',

  SYSTEM_MENU: 'system-menu',
  SYSTEM_MENU_LIST: 'system-menu-list',
  SYSTEM_MENU_ADD: 'system-menu-add',
  SYSTEM_MENU_EDIT: 'system-menu-edit',

  SYSTEM_DEPT: 'system-dept',
  SYSTEM_DEPT_LIST: 'system-dept-list',
  SYSTEM_DEPT_ADD: 'system-dept-add',
  SYSTEM_DEPT_EDIT: 'system-dept-edit',

  SYSTEM_CONFIG: 'system-config',
  SYSTEM_LOG: 'system-log',
  SYSTEM_MONITOR: 'system-monitor',

  // 租户管理
  TENANT: 'tenant',
  TENANT_LIST: 'tenant-list',
  TENANT_ADD: 'tenant-add',
  TENANT_EDIT: 'tenant-edit',
  TENANT_DETAIL: 'tenant-detail',

  // 个人中心
  PROFILE: 'profile',
  PROFILE_INFO: 'profile-info',
  PROFILE_SECURITY: 'profile-security',
  PROFILE_SETTINGS: 'profile-settings',

  // 错误页面
  ERROR_403: 'error-403',
  ERROR_404: 'error-404',
  ERROR_500: 'error-500',

  // 其他
  ABOUT: 'about',
  HELP: 'help',
  CONTACT: 'contact'
} as const

/**
 * 路由路径常量
 */
export const ROUTE_PATHS = {
  // 根路径
  ROOT: '/',

  // 认证相关
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // 主要页面
  DASHBOARD: '/dashboard',
  HOME: '/home',

  // 系统管理
  SYSTEM: '/system',
  SYSTEM_USER: '/system/user',
  SYSTEM_USER_LIST: '/system/user/list',
  SYSTEM_USER_ADD: '/system/user/add',
  SYSTEM_USER_EDIT: '/system/user/edit',
  SYSTEM_USER_DETAIL: '/system/user/detail',

  SYSTEM_ROLE: '/system/role',
  SYSTEM_ROLE_LIST: '/system/role/list',
  SYSTEM_ROLE_ADD: '/system/role/add',
  SYSTEM_ROLE_EDIT: '/system/role/edit',
  SYSTEM_ROLE_DETAIL: '/system/role/detail',

  SYSTEM_PERMISSION: '/system/permission',
  SYSTEM_PERMISSION_LIST: '/system/permission/list',
  SYSTEM_PERMISSION_ADD: '/system/permission/add',
  SYSTEM_PERMISSION_EDIT: '/system/permission/edit',
  SYSTEM_PERMISSION_DETAIL: '/system/permission/detail',

  SYSTEM_MENU: '/system/menu',
  SYSTEM_MENU_LIST: '/system/menu/list',
  SYSTEM_MENU_ADD: '/system/menu/add',
  SYSTEM_MENU_EDIT: '/system/menu/edit',

  SYSTEM_DEPT: '/system/dept',
  SYSTEM_DEPT_LIST: '/system/dept/list',
  SYSTEM_DEPT_ADD: '/system/dept/add',
  SYSTEM_DEPT_EDIT: '/system/dept/edit',

  SYSTEM_CONFIG: '/system/config',
  SYSTEM_LOG: '/system/log',
  SYSTEM_MONITOR: '/system/monitor',

  // 租户管理
  TENANT: '/tenant',
  TENANT_LIST: '/tenant/list',
  TENANT_ADD: '/tenant/add',
  TENANT_EDIT: '/tenant/edit',
  TENANT_DETAIL: '/tenant/detail',

  // 个人中心
  PROFILE: '/profile',
  PROFILE_INFO: '/profile/info',
  PROFILE_SECURITY: '/profile/security',
  PROFILE_SETTINGS: '/profile/settings',

  // 错误页面
  ERROR_403: '/error/403',
  ERROR_404: '/error/404',
  ERROR_500: '/error/500',

  // 其他
  ABOUT: '/about',
  HELP: '/help',
  CONTACT: '/contact'
} as const

/**
 * 路由元信息类型
 */
export interface RouteMetaInfo {
  title?: string
  icon?: string
  auth?: string | string[]
  roles?: string | string[]
  permissions?: string | string[]
  hidden?: boolean
  keepAlive?: boolean
  affix?: boolean
  breadcrumb?: boolean
  activeMenu?: string
  noCache?: boolean
  alwaysShow?: boolean
}

/**
 * 路由配置类型
 */
export interface RouteConfig {
  name: string
  path: string
  component?: any
  redirect?: string
  meta?: RouteMetaInfo
  children?: RouteConfig[]
}

/**
 * 导出路由类型
 */
export type RouteNameType = typeof ROUTE_NAMES[keyof typeof ROUTE_NAMES]
export type RoutePathType = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS]
